import type { Endgame } from "./types";
import type { Beat } from "@/lib/tutorial/types";
import type { LessonGuide } from "./lesson-guides";
import { PAWN_ENDGAMES } from "./endgames-pawns";
import { PIECE_ENDGAMES } from "./endgames-pieces";

/**
 * Everything one endgame lesson needs in one place: the position and explanation
 * (ENDGAMES), the 3D demonstration (ENDGAME_VISUALS) and the checkpoint (LESSON_GUIDES).
 * The core six live in their original files; these are merged in from the batches below.
 */
export type EndgameLesson = { endgame: Endgame; beats: Beat[]; guide: LessonGuide };

export const EXTRA_ENDGAMES: EndgameLesson[] = [...PAWN_ENDGAMES, ...PIECE_ENDGAMES];
